import '@oas-ui/i18n'
import { OASSwipeCell } from './oas-swipe-cell.js'

if (!customElements.get('oas-swipe-cell')) {
  customElements.define('oas-swipe-cell', OASSwipeCell)
}

export { OASSwipeCell }
